<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="formgrid grid">
          <div class="field col-12">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="form.name"
              class="w-full"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field col-12">
            <label class="font-medium">Описание</label>
            <crm-editor [(value)]="form.description"></crm-editor>
            <small
              *ngIf="errors?.description"
              class="p-error">
              {{ errors.description | join }}
            </small>
          </div>

          <div class="field col-12">
            <label class="font-medium required-field">Цена за пользователя</label>
            <p-inputNumber
              [(ngModel)]="form.price"
              class="w-full {{ errors?.price ? 'ng-invalid ng-dirty' : '' }}"
              styleClass="w-full {{ errors?.price ? 'ng-invalid ng-dirty' : '' }}"
              [min]="0"></p-inputNumber>
            <small
              *ngIf="errors?.price"
              class="p-error">
              {{ errors.price | join }}
            </small>
          </div>

          <div class="field col-12">
            <label class="font-medium required-field">Модули</label>
            <crm-multi-select
              [options]="modules"
              [(selectedItems)]="compatAvailableModules"
              (selectedItemsChange)="onModulesChange()"
              [class]="errors?.modulesAccessControl ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.modulesAccessControl ? 'ng-invalid ng-dirty' : ''"
              optionValue="name"
              display=""
              appendTo="body">
              <ng-template
                #selectedItemsTemplate
                let-items="items">
                <ng-container *ngFor="let item of items; last as isLast">
                  {{ getModuleDisplayName(item.value) }}{{ isLast ? '' : ', ' }}
                </ng-container>
              </ng-template>
              <ng-template
                #itemTemplate
                let-option="item">
                <div>
                  <p>{{ getModuleDisplayName(option.value) }}</p>
                  <small class="text-gray-400">{{ getModuleDescription(option.value) }}</small>
                </div>
              </ng-template>
            </crm-multi-select>
            <small
              *ngIf="errors?.modulesAccessControl"
              class="p-error">
              {{ errors.modulesAccessControl | join }}
            </small>
            <small class="text-gray-400"> Базовый модуль уже включен. </small>
          </div>

          <div
            class="field col-12"
            *ngIf="editableTabs?.length > 0">
            <label class="font-medium">Исключить вкладки модулей</label>
            <crm-multi-select
              [options]="editableTabs"
              [(selectedItems)]="excludedTabs"
              optionValue="name"
              sort=""
              display=""
              placeholder="Выберите вкладки для отключения"
              appendTo="body">
              <ng-template
                #selectedItemsTemplate
                let-items="items">
                <ng-container *ngFor="let item of items; last as isLast">
                  {{ getTabDisplayName(item.value) }}{{ isLast ? '' : ', ' }}
                </ng-container>
              </ng-template>
              <ng-template
                #itemTemplate
                let-item="item">
                <div>
                  <p>{{ getTabDisplayName(item.value) }}</p>
                  <small class="text-gray-400">{{ getModuleNameByTab(item.value) }}</small>
                </div>
              </ng-template>
            </crm-multi-select>
            <small class="text-gray-400">
              Здесь отображаются только те вкладки выбранных модулей, которые разрешено отключать.
            </small>
          </div>

          <div class="field-checkbox col-12">
            <p-checkbox
              [(ngModel)]="form.isDefault"
              [binary]="true"
              inputId="isDefault"></p-checkbox>
            <label [for]="'isDefault'">По умолчанию</label>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="grid mt-3">
    <div class="col-12 flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success mr-2"
        (onClick)="saveItem()"></crm-button>
      <crm-button
        *ngIf="(form$ | async)?.isEdit"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteRatePlan()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
